import { IFileNode, IFileTreeNode } from '@apiHooks';
import { IResultSensitivityLabel } from '../../../apiHooks/sensitivityLabelApi';

export enum ResultState {
    cancelled = 'Cancelled',
    completed = 'Completed',
    error = 'Error',
    running = 'Pending',
    unknown = 'Unknown',
}

export interface IFileNodeWrapper {
    type: 'input' | 'output';
    node: IFileNode | IFileTreeNode;
}

export interface IResult {
    allowedRemoteHosts: string[];
    linkableRemoteHosts: string[];
    appUri: string;
    authToken: string;
    finishedAt: string;
    isOwnedByUser: boolean;
    isResultAvailable: boolean;
    mainOutputFilePath: string | null;
    name: string;
    noteCount: number;
    presigned_output_storage_url: string;
    shareableLink: string;
    created_at: string;
    state: ResultState;
    uuid: string | null;
    can_access_all_results_of_user: boolean;
    can_access_all_index_tables_of_user: boolean;
    can_access_all_data_records_of_user: boolean;
    can_access_oauth_token_of_user: boolean;
    error_code?: number;
    requested_machine?: string;
    main_output_port: number | null;
    requires_user_identity?: boolean;
    results_proxy_hostname?: string;
    visualization_prefer_full_width?: boolean;
    send_notifications_to_user?: boolean;
    sensitivityLabels: IResultSensitivityLabel[];
}

export enum View {
    details = 'Details',
    logs = 'Logs',
    main = 'Main',
    metrics = 'Metrics',
    notes = 'Notes',
}

export interface ISelectedDirectory {
    path: string;
    type: 'input' | 'output';
}

export enum ExperimentView {
    results = 'results',
    details = 'details',
    share = 'share',
}
